import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
  * **GuestDiary**
  *
  * @exports bs_466
  * @category engines
  */
const factory = function factory({ document, thn }) {
    let refreshPrice = null;
    const roomDetailsParseData = (numAdults, numChildren, nights) => {
        const roomsArray = Array.from(document.querySelectorAll('.search-result-wrapper'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.searchItemTitle')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.rateplan-wrapper')).map((rate) => {
                const rateName = rate.querySelector('.rateplan-name')?.textContent;
                const ratePrice = thn.parseNumber(rate?.querySelector('.rateQuotedPrice')?.textContent);
                const hasBreakfast = true;
                const isRefundable = !rate.querySelector('.rate-info-panel')?.textContent?.match(/Non refundable|Non remboursable|không hoàn trả/);
                if (!ratePrice || !rateName) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice / nights,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const lang = document.querySelector('#CheckoutLanguageSelector span')?.getAttribute('lang');
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        boot() {
            const container = document.querySelector('body');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                }, 800);
                thn.observeDom(container, refreshPage, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('.checkout-content-container');
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh();
                }, 500);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: false,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.host.includes('bookingengine.myguestdiary');
            // https://bookingengine.myguestdiary.com/1805/2024-07-16/2024-07-17/2/0/1/?_gl=1*1d6go83*_ga*NTA3MjgzMzUuMTcyMTAyNzg5NA..*_ga_0WHG31ZXE0*MTcyMTExNTMzOS4zLjEuMTcyMTExODc1MC4wLjAuMA..
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Dates
            const dates = document.querySelector('#mobile_search_results span')?.textContent?.split('-');
            if (!dates) {
                return null;
            }
            const dateBeginWithoutYear = dates?.[0]?.trim();
            const dateEndWithoutYear = dates?.[1]?.trim();
            const year = document.querySelector('#datepicker')?.value?.slice(-4);
            if (!year) {
                return null;
            }
            const dateBeginNoFormat = `${dateBeginWithoutYear} ${year}`;
            const dateEndNoFormat = `${dateEndWithoutYear} ${year}`;
            const dateBegin = translateDate(dateBeginNoFormat, thn.data.language);
            const dateEnd = translateDate(dateEndNoFormat, thn.data.language);
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd);
            // Guests, Adults & Children
            const adults = thn.parseNumber(document.querySelector('#search_adults')?.value) || 2;
            const children = thn.parseNumber(document.querySelector('#search_children')?.value) || 0;
            // Price & currency
            const pricesEl = Array.from(document.querySelectorAll('.rateQuotedPrice'));
            const prices = pricesEl.map((price) => thn.parseNumber(price?.textContent)).filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(document.querySelector('#checkoutCurrencySelector')?.textContent?.trim());
            const noAvailability = document.querySelector('.search-error');
            if (!thn.empty(prices) && currency && nights && !noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    price: Math.min(...prices) / nights,
                    currency,
                    roomDetails: roomDetailsParseData(adults, children, nights),
                };
            }
            if (noAvailability) {
                return {
                    adults,
                    children,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            // BookingID
            const bookingId = document.querySelector('.reservationId')?.textContent;
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const dateBeginEl = document.querySelector('.itemCheckin')?.textContent || '';
            const dateEndEl = document.querySelector('.itemCheckout')?.textContent || '';
            const dateBegin = translateDate(dateBeginEl, thn.data.language);
            const dateEnd = translateDate(dateEndEl, thn.data.language);
            // Price & Currency
            const priceAndCurrency = document.querySelector('.billBalance')?.textContent;
            const price = thn.parseNumber(priceAndCurrency);
            const currency = thn.parseCurrency(priceAndCurrency);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
